import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiInstagram, FiFacebook, FiYoutube } from 'react-icons/fi';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { to: '/', label: 'Home' },
    { to: '/services', label: 'Services' },
    { to: '/transformations', label: 'Transformations' },
    { to: '/recipes', label: 'Recipes' },
    { to: '/blog', label: 'Blog' },
  ];

  const services = [
    'Weight Loss Programs',
    'Weight Gain Programs',
    'Disease Management',
    'Skin Toning',
    'Customized Diet Plans',
    'Virtual Coaching',
    'Monthly Plans',
  ];

  return (
    <footer className="bg-secondary-50 text-neutral-800">
      {/* Main Footer Content */}
      <div className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
            {/* Company Info */}
            <div className="col-span-2 md:col-span-1 space-y-4">
              <Logo 
                variant="main" 
                size="navbar" 
                animated={false}
                showText={true}
              />
              <p className="text-neutral-600 text-xs md:text-sm">
                Transform your health with personalized nutrition guidance and proven programs. 
                Your journey to a healthier you starts here.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://www.instagram.com/d_fitclub_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-secondary-200 rounded-lg flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors text-secondary-700"
                  title="Follow us on Instagram"
                >
                  <FiInstagram className="w-5 h-5" />
                </a>
                <a
                  href="https://www.facebook.com/share/1Axj8uhKsP/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-secondary-200 rounded-lg flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors text-secondary-700"
                  title="Follow us on Facebook"
                >
                  <FiFacebook className="w-5 h-5" />
                </a>
                <a
                  href="https://www.youtube.com/@fit_with_Deeksha"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-secondary-200 rounded-lg flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors text-secondary-700"
                  title="Follow us on YouTube"
                >
                  <FiYoutube className="w-5 h-5" />
                </a>

              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-sm md:text-lg font-semibold mb-2 md:mb-4 text-neutral-800">Quick Links</h3>
              <ul className="space-y-1 md:space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-neutral-600 hover:text-primary-600 transition-colors text-xs md:text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link
                    to="/about"
                    className="text-neutral-600 hover:text-primary-600 transition-colors text-xs md:text-sm"
                  >
                    About Deeksha
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-neutral-600 hover:text-primary-600 transition-colors text-xs md:text-sm"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-sm md:text-lg font-semibold mb-2 md:mb-4 text-neutral-800">Our Services</h3>
              <ul className="space-y-1 md:space-y-2">
                {services.map((service, index) => (
                  <li key={index}>
                    <span className="text-neutral-600 text-xs md:text-sm">{service}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-sm md:text-lg font-semibold mb-2 md:mb-4 text-neutral-800">Get in Touch</h3>
              <div className="space-y-2 md:space-y-3">
                <div className="flex items-center space-x-3">
                  <FiPhone className="w-5 h-5 text-primary-600" />
                  <span className="text-neutral-600 text-xs md:text-sm">+91-9355353459</span>
                </div>
                <div className="flex items-center space-x-3">
                  <FiMail className="w-5 h-5 text-primary-600" />
                  <span className="text-neutral-600 text-xs md:text-sm">contact@dfitclub.com</span>
                </div>

                <div className="flex items-start space-x-3">
                  <FiMapPin className="w-5 h-5 text-primary-600 mt-1" />
                  <span className="text-neutral-600 text-xs md:text-sm">
                    Online Consultations<br />
                    Available Worldwide
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-secondary-200">
        <div className="container-max py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-neutral-500">
              © {currentYear} Dfitclub by Deeksha Rajput. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-neutral-500 hover:text-primary-600 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-neutral-500 hover:text-primary-600 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-neutral-500 hover:text-primary-600 transition-colors">
                Disclaimer
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;